import { useState } from "react";

type InputType<T> = {
    autoFocus?: boolean;
    label?: string;
    field: keyof T;
    className?: string;
    required?: boolean;
    type?: "text" | "textarea" | "number" | "date" | "datetime-local" | "email" | "password";
    placeholder?: string;
    maxLength?: number;
    value: T;
    setValue: React.Dispatch<React.SetStateAction<T | null>>;
    onEnter?: () => any;
};

export function Input<T>({ autoFocus, label, placeholder, type = "text", className = "", maxLength, required = false, value, setValue, field, onEnter }: InputType<T>) {

    function onChange(newValue: any) {
        if (typeof maxLength === "number" && typeof newValue === "string" && newValue.length > maxLength)
            newValue = newValue.slice(0, maxLength);

        setValue({ ...value, [field]: newValue });
    }

    if (type === "number") {
        return <div>
            {label && <label>{label} {required && "*"}</label>}
            <InputNumber value={Number(value[field])} onChange={onChange} />
        </div>;
    }

    return <div className={"form-input " + className}>
        {label && <label>{label} {required && "*"}</label>}
        {type !== "textarea" && <input
            autoFocus={autoFocus}
            type={type}
            value={String(value[field])}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            onKeyUp={e => e.key === 'Enter' && onEnter?.()}
        />}
        {type === "textarea" && <textarea
            value={String(value[field])}
            onChange={(e) => onChange(e.target.value)}
        />}
        {maxLength && <div className="max-length">{String(value[field]).length} / {maxLength}</div>}
    </div>;
}

export function Checkbox({ value, color = "", onChange }: { value: boolean, color?: string, onChange?: (value: boolean) => void }) {
    return <div className={`checkbox block ${value ? "on" : "off"} bg-${color}`} onClick={() => onChange?.(!value)} >
        {/* TODO <input style={{ display: "none", pointerEvents: "none" }} type="checkbox" checked={value} onChange={e => onChange(e.target.checked)} /> */}
    </div>
}

type CheckboxPublicProps<T> = {
    label: string;
    captionPublic?: string;
    captionPrivate?: string;
    value: T;
    onChange: React.Dispatch<React.SetStateAction<T>>;
};

export function CheckboxPublic<T extends { public: boolean }>({ value, onChange, label, captionPublic, captionPrivate }: CheckboxPublicProps<T>) {
    return <>
        <label onClick={() => onChange({ ...value, public: !value.public })}>
            <Checkbox value={value.public} />
            {label}
        </label>
        {captionPublic && captionPrivate && <p className="label caption">{value.public ? captionPublic : captionPrivate}</p>}
    </>;
}


export function InputNumber({ value, min, max, onChange }: { value: number, min?: number, max?: number, onChange: (value: number) => void }) {
    const [text, setText] = useState(value.toString());
    return <input
        className={parseInt(text).toString() === text ? "valid" : "no-valid"}
        type="number"
        min={min}
        max={max}
        step={1}
        value={text}
        onChange={e => setText(e.target.value)}
        onBlur={() => {
            let value = parseInt(text);

            if (isNaN(value)) value = 0;
            if (typeof min === "number" && value < min)
                value = min;
            if (typeof max === "number" && value > max)
                value = max;

            setText(value.toString());
            onChange(value);
        }}
    />;
}